const Configuracion = 
  {
    proyecto: "afirmeedomex",
    aplicacion:"EDOMEX-AFIRME",
    version: "1.2.1",
    derechos:"POWER BY © SINESTRY 2025",
    basedatos:"siniestrosapdb",
    mensajesplash:"",
    author:"Ing.Juan Carlos Arreola Lopez",
    urlapi://' ttp://localhost:4001',
            'https://sinestrydev-552789706120.us-central1.run.app',
            //'https://sinieistrosapidev-552789706120.us-central1.run.app',
           //'https://sinapidev-552789706120.us-central1.run.app',
           /*'https://siniestrosapi2dev-552789706120.us-central1.run.app',"http://localhost:4001", */
  };
export default Configuracion;

